import { render, staticRenderFns } from "./DuplicateCatalog.vue?vue&type=template&id=b565a57a&scoped=true"
import script from "./DuplicateCatalog.vue?vue&type=script&lang=js"
export * from "./DuplicateCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b565a57a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b565a57a')) {
      api.createRecord('b565a57a', component.options)
    } else {
      api.reload('b565a57a', component.options)
    }
    module.hot.accept("./DuplicateCatalog.vue?vue&type=template&id=b565a57a&scoped=true", function () {
      api.rerender('b565a57a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/catalogs/DuplicateCatalog.vue"
export default component.exports